import { Component, OnInit } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { Observable } from 'rxjs';

import * as fromEasel from '../../../easel/state/easel.reducer';
import * as easelActions from '../../../easel/state/easel.actions';
import * as fromRoot from '../../../../state/app.reducer';
import * as rootActions from '../../../../state/app.actions';

import { Easel} from '../../../../_models/easel';
import { EaselType } from '../../../../_models/easel_type';
import { EaselFamily } from '../../../../_models/easel_family';
import { Product } from '../../../../_models/product';

@Component({
  templateUrl: './easel-edit-shell.component.html'
})

export class EaselEditShellComponent implements OnInit {

    easel$: Observable<Easel>;
    easelTypeList$: Observable<EaselType[]>;
    easelFamilyList$: Observable<EaselFamily[]>;
    freightList$: Observable<Product[]>;

  constructor(
    private storeRoot: Store<fromRoot.State>,
    private store: Store<fromEasel.State>
  ) {}

  ngOnInit() {

    this.easel$ = this.store.pipe(select(fromEasel.getCurrentEasel)) as Observable<Easel>;
    this.easelTypeList$ = this.store.pipe(select(fromEasel.getEaselTypes)) as Observable<EaselType[]>;
    this.easelFamilyList$ = this.store.pipe(select(fromEasel.getEaselFamilies)) as Observable<EaselFamily[]>;
    this.freightList$ = this.store.pipe(select(fromEasel.getFreightList)) as Observable<Product[]>;
  }

  saveEasel(easelIn: Easel): void {

    console.log('---> saveEasel easelIn:');
    console.log(easelIn);

    if (easelIn.id === null) {
      console.log('Se va a CREAR una nueva obra.');
      this.store.dispatch( new easelActions.CreateEasel(easelIn));
    } else {
      console.log('Se va a MODIFICAR una obra existente.');
      this.store.dispatch( new easelActions.UpdateEasel(easelIn));
    }
  }

  // --------------------------------------------------------------
  // Función para mostrar la ventana genérica de información.
  showInfoModal(modalParams) {

    console.log('---->>>>.... Ejecutando prodData-edit-shell showInfoModal: '
    + modalParams.value + ' ;Info: ' + modalParams.info + ' ;Link: ' + modalParams.link + ' ;Skin: ' + modalParams.skin);

    this.storeRoot.dispatch( new rootActions.ChangeInfoModal({
      value: modalParams.value,
      info: modalParams.info,
      link: modalParams.link,
      param: modalParams.param,
      skin: modalParams.skin
    }));

  } // End function showInfoModal


} // End class EaselEditShellComponent
